import { Row, Col, Collapse, Switch, Skeleton, Select, Button, Tooltip, notification} from "antd";
import { Children, useEffect, useState } from "react";
import { getDeckleFormats, getJobCardCylinders, getJobCardsById, getJobCardsByIdMultistage, getMultiStageJobCardCylinders, saveDefaultSelectionForJobCardPrint } from "../../Services/deckleMatchServices";
import styled from "styled-components";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import { GlobalSet } from "../pageStyled";
import CSV from "./CSV";
import { getCompanyDetails } from "../../Services/companyServices";
import Iconmoon from "../../Components/IconsFiles/icon";
import { conversionFactorUnitsToTonne, CoversionFactorUnitsToCM } from "../../Utils/Constant/MeasurementUnitList";

const CSVRow = styled(Row)`
    min-height: 80vh;
    width: 100%;
    .siderCSV {
        height: 80vh;
        overflow-y: scroll;
        border-right: #edebe9 solid 1px;
        padding: 0px 20px 20px 0px;
        .header {
            padding: 20px 0px;
            display: flex;
            flex-direction: column;
            align-items: start;
            div{
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom:6px;
            }
            h3{
                font-weight: 600;
                font-size: 21px;
                letter-spacing: 0.4px;
                margin-bottom: 0px !important;
            }
            p{
                color: #4b5563;
                font-weight: 300;
                line-height: 1.5;
                margin-bottom: 0px
            }
            svg{
                cursor: pointer;
            }
        }
    }
    .collapse {
        display: flex;
        flex-direction: column;
        gap: 20px;
        &>div{
            border: 1px solid #edebe9 !important;
            border-radius: 8px !important;
        }
    }
    .mainCSV {
        overflow-y: scroll;
        height: 80vh;
        padding: 30px;
        div{
            border: 1px solid #edebe9;
            border-radius: 8px;
            overflow-x: scroll;
            min-width: 100%;
            table{
                min-width: 100%;
            }
            tr,td,th {
                border: 1px solid #edebe9;
            }
            td, th{
                padding: 5px 15px; 
                white-space: nowrap;
            }
            .patternSetData{
                background-color: rgb(253, 238, 234);
            }
            .orderDataHeader{
                background-color: #f3f4f6;
                td{
                    font-weight: bold;
                }
            }
        }

    }
    .toggleGroup {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-block: 4px;
        span{
            font-weight: 300;
        }
        div{
            display: flex;
            div{
                display: flex;
                justify-content: center;
                gap: 3px;
                margin-right: 7px;
                svg{
                    cursor: pointer;
                    &:hover{
                        color: #ea655b;
                    }
                }
            }
        }
    }
`

const FieldsToggles = ({data,setData,movable = false}) => {

    const groupReels = () => {
        const updatedData = {};
        let isRowDataMatched = {};
        
        Object.entries(data)?.forEach((entry)=>{
            const key = entry[0];
            const orderInfo = entry[1];
            let updatedValueData = [];

            orderInfo?.value?.forEach((patternArray,patterNo)=>{
                let updatedPatternData = [];
                patternArray?.forEach((rowVal,rowNo)=>{
                    let isPreviousRowMatched = false,matchedInd = -1;

                    if(Object.keys(isRowDataMatched)?.includes(`${patterNo}-${rowNo}`))
                    {
                        isPreviousRowMatched = isRowDataMatched[`${patterNo}-${rowNo}`]?.isMatched;
                        matchedInd = isRowDataMatched[`${patterNo}-${rowNo}`]?.matchedInd;
                    }
                    else{
                        const currentOrders = data?.order_no?.value[patterNo][rowNo];//can be array of single vlaue
    
                        let ordersInd = data?.order_no?.value[patterNo]?.slice(0,rowNo)?.findIndex((rowOrders)=>JSON.stringify(rowOrders) == JSON.stringify(currentOrders));
    
                        let currentSheeterPattern = data?.sheeter_pattern?.value[patterNo][rowNo] ?? "%";
                        let matchedSheeterPattern = ordersInd != -1 ?data?.sheeter_pattern?.value[patterNo][ordersInd] ?? "#" :"#";
                        let currentWidth = data?.width?.value[patterNo][rowNo];
                        let matchedWidth = ordersInd != -1 ?data?.width?.value[patterNo][ordersInd] :"#";
    
                        if(currentSheeterPattern == matchedSheeterPattern || currentWidth == matchedWidth)
                        {
                            isPreviousRowMatched = true;
                            matchedInd = ordersInd;
                        }
                        isRowDataMatched[`${patterNo}-${rowNo}`] = {
                            isMatched: isPreviousRowMatched,
                            matchedInd: matchedInd
                        }
                    }

                    if(isPreviousRowMatched)
                    {
                        if(key == "reels_count")
                            updatedPatternData[matchedInd] = parseInt(updatedPatternData[matchedInd]) + 1;
                        else if(key == "reel_weight")
                            updatedPatternData[matchedInd] = (parseFloat(updatedPatternData[matchedInd]) + parseFloat(rowVal))?.toFixed(3);  
                    }
                    else{
                        updatedPatternData.push(rowVal);
                    }
                })
                if(updatedPatternData.length != 0)
                    updatedValueData?.push(updatedPatternData);
            })

            //adding keys in updated data with updated values 
            updatedData[key] = {
                ...orderInfo,
                value: updatedValueData,
            }
            
        })

        //save updated orderInfor to state
        setData(updatedData);
    }

    const separateReels = () => {
        const updatedData = {};
        Object.entries(data)?.forEach((entry)=>{
            const key = entry[0];
            const orderInfo = entry[1];
            let updatedValueData = [];

            orderInfo?.value?.forEach((patternArray,patterNo)=>{
                let updatedPatternData = [];
                patternArray?.forEach((rowVal,rowNo)=>{
                    const reel_count = Number(data?.reels_count?.value[patterNo][rowNo]);
                    for(let i=1;i<=reel_count;i++)
                    {
                        if(key == "reels_count")
                            updatedPatternData.push(Number(rowVal) / reel_count);
                        else if(key == "reel_weight")
                            updatedPatternData.push((Number(rowVal) / reel_count).toFixed(3));
                        else
                            updatedPatternData.push(rowVal);
                    }
                })
                updatedValueData?.push(updatedPatternData);
            })

            //adding keys in updated data with updated values 
            updatedData[key] = {
                ...orderInfo,
                value: updatedValueData,
            }
            
        })

        //save updated orderInfor to state
        setData(updatedData);
    }

    const handleToggleChange = (key) => {
        if(key == "reels_count")
        {
            const changedValue = !data?.reels_count?.visible;
            if(changedValue)
            {
                groupReels();
            }
            else{
                separateReels();
            }
        }
        setData(prev=>({
            ...prev,
            [key]: {
                ...prev[key],
                visible: !prev[key]?.visible,
            }
        }))
    }

    const moveUp = (key) => {
        let formattedData = {};
        let entries = Object.entries(data);
        entries.forEach((item,ind)=>{
            if(ind == key)
            {
                formattedData[entries[ind-1][0]] = entries[ind-1][1];
            }
            else if(ind == key-1)
            {
                formattedData[entries[ind+1][0]] = entries[ind+1][1];
            }
            else
            {
                formattedData[item[0]] = item[1];
            }
        })
        setData(formattedData);
        console.log("FD",formattedData)
    }

    const moveDown = (key) => {
        let formattedData = {};
        let entries = Object.entries(data);
        entries.forEach((item,ind)=>{
            if(ind == key)
            {
                formattedData[entries[ind+1][0]] = entries[ind+1][1];
            }
            else if(ind == key+1)
            {
                formattedData[entries[ind-1][0]] = entries[ind-1][1];
            }
            else {
                formattedData[item[0]] = item[1];
            }
        })
        setData(formattedData);
    }

    return (
        data && <div>
            {Object.entries(data).map((item,ind)=>{
                return (
                    <div className="toggleGroup">
                        <span>{item[0] == "reels_count"?"Group Reels Count":item[1]?.label}</span>
                        <div>
                            {movable && <div>
                                <Iconmoon icon={"circle-up"} size={16} color={"#6b778c"} onClick={()=>moveUp(ind)} style={{visibility:`${ind != 0 ?"visible":"hidden"}`}}/>
                                <Iconmoon icon={"circle-down"} size={16} color={"#6b778c"} onClick={()=>moveDown(ind)} style={{visibility:`${ind != Object.entries(data)?.length-1?"visible":"hidden"}`}}/>
                            </div>}

                            <GlobalSet>
                                <Switch 
                                    size="small"
                                    checked={item[1]?.visible}
                                    onChange={()=>handleToggleChange(item[0])}
                                    className="switch-new"
                                    disabled={!item[1]?.toggle}
                                />
                            </GlobalSet>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

const CSVJobCardViewer = ({type,machineType,solution,orderDetails,jobId,jobCardCode,print,setPrint,loading,setLoading,selectedSheet}) => {
    const [runData,setRunData] = useState(null);
    const [patternData,setPatternData] = useState(null);
    const [setData,setSetData] = useState(null);
    const [orderData,setOrderData] = useState(null);
    const [orderDataForSummary,setOrderDataForSummary] = useState(null);
    const [formatsResp,setFormatsResp] = useState(null);
    const [company,setCompany] = useState(null);
    const toggleableFields = selectedSheet == "sheet_1"?[
        {
            key: 1,
            label: "Basic Run Information",
            children: <FieldsToggles data={runData} setData={setRunData} />
        },
        {
            key: 2,
            label: "Pattern Specific Information",
            children: <FieldsToggles data={patternData}  setData={setPatternData} />
        },
        {
            key: 3,
            label: "Sets Information",
            children: <FieldsToggles data={setData} setData={setSetData} />
        },
        {
            key: 4,
            label: "Orders Information",
            children: <FieldsToggles data={orderData} setData={setOrderData} movable={true}/>
        }
    ]:[
        {
            key: 1,
            label: "Orders Information",
            children: <FieldsToggles data={orderDataForSummary} setData={setOrderDataForSummary} movable={true}/>
        }
    ];

    useEffect(()=>{
        //Calling of apis
        (async()=>{
            try{
                let formatsResp = await getDeckleFormats();
                const csvFormat = formatsResp?.formats?.filter((format)=>format?.name == "csv_format")[0];
                let keysData = csvFormat?.keys;
                setFormatsResp(formatsResp);
                let response1,response2;
                if (type == "singleStage")
                {
                    response1 = (machineType == "rewinder") ?await getJobCardCylinders(jobId,420): {};
                    response2 = await getJobCardsById(jobId);
                }
                else{
                    response1 = await getMultiStageJobCardCylinders(jobId,420);
                    response2 = await getJobCardsByIdMultistage(jobId);
                }
                let sol_group = `sol_${solution}_groups`;
                let sol = `solution_${solution}`;
                
                //setting companyDetails
                const companyData = await getCompanyDetails();
                setCompany(companyData?.data);

                let runInfo = {
                    jc_no : {
                        label: "Run No",
                        value: response2?.jobcard_code?.replaceAll('~',""),
                        visible: keysData?.runInfo?.jc_no?.visible,
                        toggle: false,
                    },
                    paper_machine : {
                        label: "Paper Machine",
                        value: response2?.jobcard?.group?.machines[0]?.name,
                        visible: keysData?.runInfo?.paper_machine?.visible,
                        toggle: true,
                    },
                    ...(response2?.type == "multi_stage" || response2?.process_type == "rewinder") ? {rewinder : {
                        label: "Rewinder",
                        value: response2?.jobcard?.group?.machines[0]?.rewinder_name,
                        visible: keysData?.runInfo?.rewinder?.visible,
                        toggle: true,
                    }}:{},
                    ...(response2?.type == "multi_stage" || response2?.process_type == "cutter") ? {cutter: {
                        label: "Cutter",
                        value: response2?.jobcard?.group?.machines[response2?.type == "multi_stage"?1:0]?.cutter_name,
                        visible: keysData?.runInfo?.cutter?.visible,
                        toggle: true,
                    }}:{},
                    date : {
                        label: "Date",
                        value: response2?.created_at?.split("T")[0],
                        visible: keysData?.runInfo?.date?.visible,
                        toggle: true,
                    },
                    grade : {
                        label: "Grade",
                        value: response2?.jobcard?.group?.grouping_params?.grade,
                        visible: keysData?.runInfo?.grade?.visible,
                        toggle: true,
                    },
                    quality : {
                        label: "Quality",
                        value: response2?.jobcard?.group?.grouping_params?.quality,
                        visible: keysData?.runInfo?.quality?.visible,
                        toggle: true,
                    },
                    gsm : {
                        label: "GSM",
                        value: response2?.jobcard?.group?.grouping_params?.gsm,
                        visible: keysData?.runInfo?.gsm?.visible,
                        toggle: true,
                    },
                    ...(response2?.type =="multi_stage" || response2?.process_type == "rewinder")?{fulfilled_weight : {
                        label: "FulFilled Weight",
                        value: `${response2?.jobcard[sol]?.data?.summary?.fulfilled_requirement_weight} ${response2?.jobcard[sol]?.data?.summary?.units?.fulfilled_requirement_weight?.toUpperCase()}`,
                        visible: keysData?.runInfo?.fulfilled_weight?.visible,
                        toggle: true,
                    }}:{
                        fulfillment_percent:{
                            label: "Fulfillment",
                            value: `${response2?.jobcard[sol]?.data?.summary?.total_fulfillment_percent?.toFixed(3)} %`,
                            visible: keysData?.runInfo?.fulfillment_percent?.visible,
                            toggle: true,
                        }
                    },
                    production_weight : {
                        label: "Production Weight",
                        value: `${response2?.jobcard[sol]?.data?.summary?.job_card_weight} ${response2?.jobcard[sol]?.data?.summary?.units?.job_card_weight.toUpperCase()}`,
                        visible: keysData?.runInfo?.production_weight?.visible,
                        toggle: true,
                    },
                    net_trim_loss : {
                        label: "Net Trim Loss",
                        value: `${((response2?.type =="multi_stage" || response2?.process_type == "rewinder")?response2?.jobcard[sol]?.data?.summary?.net_trim_loss_percentage:response2?.jobcard[sol]?.data?.summary?.net_trimloss_percent_width)?.toFixed(3)} %`,
                        visible: keysData?.runInfo?.net_trim_loss?.visible,
                        toggle: true,
                    },
                    priority_quantity : {
                        label: "Priority Quantity",
                        value: (response2?.type =="multi_stage" || response2?.process_type == "rewinder")?`${response2?.jobcard[sol]?.data?.summary?.forced_weight_requirement?.toFixed(3)} ${response2?.jobcard[sol]?.data?.summary?.units?.forced_weight_requirement?.toUpperCase()}`:response2?.jobcard[sol]?.data?.summary?.requirement_priority_quantity,
                        visible: keysData?.runInfo?.priority_quantity?.visible,
                        toggle: true,
                    },
                    stock_quantity : {
                        label: "Stock Quantity",
                        value: (response2?.type =="multi_stage" || response2?.process_type == "rewinder")?`${response2?.jobcard[sol]?.data?.summary?.stock_weight_requirement?.toFixed(3)} ${response2?.jobcard[sol]?.data?.summary?.units?.stock_weight_requirement?.toUpperCase()}`:response2?.jobcard[sol]?.data?.summary?.requirement_stock_quantity,
                        visible: keysData?.runInfo?.stock_quantity?.visible,
                        toggle: true,
                    },
                    ...(response2?.type == "multi_stage" || response2?.process_type == "rewinder")?{reels_count : {
                        label: "No. of Reels",
                        value: response2?.type == "multi_stage" ? response2?.jobcard[sol]?.data?.summary?.finished_reels + response2?.jobcard[sol]?.data?.summary?.intermediate_reels : response2?.jobcard[sol]?.data?.summary?.reel_requirement_fulfilled,
                        visible: keysData?.runInfo?.reels_count?.visible,
                        toggle: true,
                    }}:{
                        sheet_count: {
                            label: "No. of Sheets",
                            value: response2?.jobcard[sol]?.data?.summary?.total_fulfillment_quantity,
                            visible: keysData?.runInfo?.sheet_count?.visible,
                            toggle: true,
                        }
                    },
                    ...(response2?.type == "multi_stage" || response2?.process_type == "cutter") ? {reels_count_cutter : {
                        label: "Reels For Cutter",
                        value: response2?.jobcard[sol]?.data?.summary?.intermediate_reels,
                        visible: keysData?.runInfo?.reels_count_cutter?.visible,
                        toggle: true,
                    }}:{},
                    
                }
                setRunData(runInfo);

                let patternInfo = {
                    pattern: {
                        label: "Pattern",
                        value: [],
                        visible: keysData?.patternInfo?.pattern?.visible,
                        toggle: false,
                    },
                    deckle_width: {
                        label: "Deckle",
                        value: [],
                        visible: keysData?.patternInfo?.deckle_width?.visible,
                        toggle: true,
                    },
                    ...(response2?.type =="multi_stage" || response2?.process_type == "rewinder")?{dia: {
                        label: "Dia",
                        value: [],
                        visible: keysData?.patternInfo?.dia?.visible,
                        toggle: true,
                    }}:{},
                    net_trim: {
                        label: "Net Trim",
                        value: [],
                        visible: keysData?.patternInfo?.net_trim?.visible,
                        toggle: true,
                    },
                    edge_trim: {
                        label: "Edge Trim",
                        value: [],
                        visible: keysData?.patternInfo?.edge_trim?.visible,
                        toggle: true,
                    }
                }

                let setInfo = {
                    sets_count: {
                        label: "No. of Sets",
                        value: [],
                        visible: keysData?.setInfo?.sets_count?.visible,
                        toggle: true,
                    },
                    sets_weight: {
                        label: "Individual Set Weight",
                        value: [],
                        visible: keysData?.setInfo?.sets_weight?.visible,
                        toggle: true,
                    },
                    sets_length: {
                        label: "Set Length",
                        value: [],
                        visible: keysData?.setInfo?.sets_length?.visible,
                        toggle: false,
                    },
                    total_set_weight: {
                        label: "Total Set Weight",
                        value: [],
                        visible: keysData?.setInfo?.total_set_weight?.visible,
                        toggle: true,
                    }
                }
                let orderInfo = {
                    width: {
                        label: "Width (cm)",
                        value: [],
                        visible: keysData?.orderInfo?.width?.visible,
                        toggle: false,
                    },
                    ...(response2?.type =="multi_stage" || response2?.process_type == "rewinder")?{reels_count: {
                        label: "Reels Count",
                        value: [],
                        visible: keysData?.orderInfo?.reels_count?.visible,
                        toggle: true,
                    }}:{},
                    ...(response2?.process_type != "rewinder")?{sheeter_pattern: {
                        label: "Sheeter Pattern (cm)",
                        value: [],
                        visible: keysData?.orderInfo?.sheeter_pattern?.visible,
                        toggle: true,
                    }}:{},
                    order_no: {
                        label: "Order Number",
                        value: [],
                        visible: keysData?.orderInfo?.order_no?.visible,
                        toggle: true,
                    },
                    grade: {
                        label: "Grade",
                        value: [],
                        visible: keysData?.orderInfo?.grade?.visible,
                        toggle: true,
                    },
                    quality: {
                        label: "Quality",
                        value: [],
                        visible: keysData?.orderInfo?.quality?.visible,
                        toggle: true,
                    },
                    gsm: {
                        label: "GSM",
                        value: [],
                        visible: keysData?.orderInfo?.gsm?.visible,
                        toggle: true,
                    },
                    burst_factor: {
                        label: "Burst Factor",
                        value: [],
                        visible: keysData?.orderInfo?.burst_factor?.visible,
                        toggle: true,
                    },
                    po_no: {
                        label: "PO Number",
                        value: [],
                        visible: keysData?.orderInfo?.po_no?.visible,
                        toggle: false,
                    },
                    customer: {
                        label: "Customer",
                        value: [],
                        visible: keysData?.orderInfo?.customer?.visible,
                        toggle: true,
                    },
                    consignee: {
                        label: "Consignee",
                        value: [],
                        visible: keysData?.orderInfo?.consignee?.visible,
                        toggle: true,
                    },
                    size: {
                        label: "Size (cm)",
                        value: [],
                        visible: keysData?.orderInfo?.size?.visible,
                        toggle: true,
                    },
                    planned_quantity: {
                        label: "Planned Quantity (T)",
                        value: [],
                        visible: keysData?.orderInfo?.planned_quantity?.visible,
                        toggle: true,
                    },
                    reel_weight: {
                        label: "Reel Weight (T)",
                        value: [],
                        visible: keysData?.orderInfo?.reel_weight?.visible,
                        toggle: true,
                    },
                    delivery_date: {
                        label: "Delivery Date",
                        value: [],
                        visible: keysData?.orderInfo?.delivery_date?.visible,
                        toggle: true,
                    },
                    remarks: {
                        label: "Remarks",
                        value: [],
                        visible: keysData?.orderInfo?.remarks?.visible,
                        toggle: true,
                    },
                    external_order_id: {
                        label: "External Order ID",
                        value: [],
                        visible: keysData?.orderInfo?.external_order_id?.visible,
                        toggle: true,
                    }
                }

                let orderInfoForSummary = {
                    order_no: {
                        label: "Order Number",
                        value: [],
                        visible: keysData?.orderInfoForSummary?.order_no?.visible,
                        toggle: false,
                    },
                    grade: {
                        label: "Grade",
                        value: [],
                        visible: keysData?.orderInfoForSummary?.grade?.visible,
                        toggle: true,
                    },
                    quality: {
                        label: "Quality",
                        value: [],
                        visible: keysData?.orderInfoForSummary?.quality?.visible,
                        toggle: true,
                    },
                    gsm: {
                        label: "GSM",
                        value: [],
                        visible: keysData?.orderInfoForSummary?.gsm?.visible,
                        toggle: true,
                    },
                    burst_factor: {
                        label: "Burst Factor",
                        value: [],
                        visible: keysData?.orderInfoForSummary?.burst_factor?.visible,
                        toggle: true,
                    },
                    po_no: {
                        label: "PO Number",
                        value: [],
                        visible: keysData?.orderInfoForSummary?.po_no?.visible,
                        toggle: true,
                    },
                    customer: {
                        label: "Customer",
                        value: [],
                        visible: keysData?.orderInfoForSummary?.customer?.visible,
                        toggle: true,
                    },
                    consignee: {
                        label: "Consignee",
                        value: [],
                        visible: keysData?.orderInfoForSummary?.consignee?.visible,
                        toggle: true,
                    },
                    size: {
                        label: "Size (cm)",
                        value: [],
                        visible: keysData?.orderInfoForSummary?.size?.visible,
                        toggle: true,
                    },
                    grain: {
                        label: "Grain",
                        value: [],
                        visible: keysData?.orderInfoForSummary?.grain?.visible,
                        toggle: true,
                    },
                    order_quantity: {
                        label: "Order Quantity (T)",
                        value: [],
                        visible: keysData?.orderInfoForSummary?.order_quantity?.visible,
                        toggle: true,
                    },
                    planned_quantity: {
                        label: "Planned Quantity (T)",
                        value: [],
                        visible: keysData?.orderInfoForSummary?.planned_quantity?.visible,
                        toggle: true,
                    },
                    fulfilled_quantity: {
                        label: "Fulfilled Quantity (T)",
                        value: [],
                        visible: keysData?.orderInfoForSummary?.fulfilled_quantity?.visible,
                        toggle: true,
                    },
                    remarks: {
                        label: "Remarks",
                        value: [],
                        visible: keysData?.orderInfoForSummary?.remarks?.visible,
                        toggle: true,
                    },
                    external_order_id: {
                        label: "External Order ID",
                        value: [],
                        visible: keysData?.orderInfoForSummary?.external_order_id?.visible,
                        toggle: true,
                    }
                }

                if(response2?.type == "multi_stage" || response2?.process_type == "rewinder"){
                    response1[sol_group]?.forEach((arr,i)=>{
                        if(arr.length)
                        {
                            let deckle_width = 0,sets_weight = 0,sets_length = 0;
                            patternInfo.pattern.value.push(`${i+1}.1`);
                            patternInfo.dia.value.push(`${response1[sol][arr[0]]?.reel_od} ${response1?.units?.reel_od}/${response1[sol][arr[0]]?.core_id} ${response1?.units?.core_id}`);
                            patternInfo.net_trim.value.push(`${response1[sol][arr[0]]?.trim_loss?.toFixed(3)} ${response1?.units?.trim_loss}`);
                            patternInfo.edge_trim.value.push(`${type=="multiStage"?response1[sol][arr[0]]?.left_edge_trim?.toFixed(3):response2?.jobcard?.group?.machines[0]?.left_edge_trim?.toFixed(3)} ${type=="multiStage"?response1?.units?.left_edge_trim:response2?.jobcard?.group?.machines[0]?.units?.left_edge_trim} (L)/ ${type=="multiStage"?response1[sol][arr[0]]?.right_edge_trim?.toFixed(3):response2?.jobcard?.group?.machines[0]?.right_edge_trim?.toFixed(3)} ${type=="multiStage"?response1?.units?.right_edge_trim:response2?.jobcard?.group?.machines[0]?.units?.right_edge_trim} (R)`);

                            setInfo.sets_count.value.push(response1[sol][arr[0]]?.actual_count);

                            Object.keys(orderInfo).forEach((key)=>{
                                orderInfo[key]?.value?.push([]);
                            })

                            response1[sol][arr[0]]?.orders?.forEach((order,j)=>{

                                if(order?.item_type != "trim_loss")
                                {
                                    let order_no,size;
                                    let ind=-1,oi=-1;  //these variables are for finding common type order data row and preventing repitoin of rows

                                    if(order?.reel_type == "intermediate_reel"){
                                        order_no = order?.intermediate_reels_data?.map(data=>data?.id);
                                        size = order?.intermediate_reels_data?.map(data=>(data?.size * CoversionFactorUnitsToCM[response1?.units?.size])?.toFixed(2));
                                        
                                        oi = orderInfo?.order_no.value[i]?.findIndex((item)=>JSON.stringify(item) == JSON.stringify(order_no));
                                        
                                        if(orderInfo.sheeter_pattern.value[i][oi] == `(${size.join(" + ")}) x ${(order?.length * CoversionFactorUnitsToCM[response1?.units?.size])?.toFixed(2)}`)
                                            ind = oi;
                                    }
                                    else if(order?.order_type == "sheet")
                                    {
                                        order_no = order?.id;
                                        size = (order?.order_width * CoversionFactorUnitsToCM[response1?.units?.order_width])?.toFixed(2);
                                        
                                        oi = orderInfo.order_no.value[i]?.indexOf(order_no);
                                        
                                        if(orderInfo.width.value[i][oi] == `${response2?.type == "single_stage" ? (order?.order_width * CoversionFactorUnitsToCM[response1?.units?.order_width])?.toFixed(2) : (order?.reel_width * CoversionFactorUnitsToCM[response1?.units?.reel_width])?.toFixed(2)}`)
                                            ind = oi;
                                    }
                                    else{
                                        order_no = order?.id;
                                        if(response2?.type == "single_stage")
                                            size = (order?.order_width * CoversionFactorUnitsToCM[response1?.units?.order_width])?.toFixed(2);
                                        else
                                            size = (order?.reel_width * CoversionFactorUnitsToCM[response1?.units?.reel_width] - order?.left_edge_trim * CoversionFactorUnitsToCM[response1?.units?.left_edge_trim] - order?.right_edge_trim * CoversionFactorUnitsToCM[response1?.units?.right_edge_trim])?.toFixed(2);
                                        
                                        oi = orderInfo.order_no.value[i]?.indexOf(order_no);
                                        
                                        if(orderInfo.width.value[i][oi] == `${response2?.type == "single_stage" ? (order?.order_width * CoversionFactorUnitsToCM[response1?.units?.order_width])?.toFixed(2) : (order?.reel_width * CoversionFactorUnitsToCM[response1?.units?.reel_width])?.toFixed(2)}`)
                                            ind = oi;
                                    }

                                    deckle_width += response2?.type == "single_stage" ? order?.order_width : order?.reel_width;
                                    sets_weight += order?.weight;
                                    
                                    //when reel_count visible then order rows with same width and orders will be merged and when false not merge
                                    if(!orderInfo?.reels_count?.visible || ind == -1)
                                    {
                                        orderInfo.width.value[i].push(`${response2?.type == "single_stage" ? (order?.order_width * CoversionFactorUnitsToCM[response1?.units?.order_width])?.toFixed(2) : (order?.reel_width * CoversionFactorUnitsToCM[response1?.units?.reel_width])?.toFixed(2)}`);
                                        orderInfo.order_no.value[i].push(order_no);
                                        orderInfo.reel_weight.value[i].push(order?.reel_type == "intermediate_reel"?order?.intermediate_reels_data?.map(data=>`${(data?.weight * conversionFactorUnitsToTonne[response1?.units?.weight?.toLowerCase()])?.toFixed(3)}`):`${(order?.weight * conversionFactorUnitsToTonne[response1?.units?.weight?.toLowerCase()])?.toFixed(3)}`);
                                        response2?.process_type != "rewinder" && orderInfo.sheeter_pattern.value[i].push(order?.reel_type == "intermediate_reel"?`(${size.join(" + ")}) x ${(order?.length * CoversionFactorUnitsToCM[response1?.units?.size])?.toFixed(2)}`:"");
                                        orderInfo.reels_count.value[i].push("1");
                                        
                                        if(order?.reel_type == "intermediate_reel")
                                        {
                                            let po_no = [],customer = [],consignee = [],order_qty = [],size = [],delivery_date = [],grade = [],quality = [],gsm = [],burst_factor = [],remarks = [],external_order_id = [];
                                            order_no?.forEach((id)=>{
                                                let orderData = orderDetails.find((order)=>order?.orderno == id);
                                                po_no.push((orderData?.pono == "null")?"SO":(orderData?.type == "Stock")?"Stock":orderData?.pono?.split("#%#")[0]);
                                                customer.push(orderData?.customername);
                                                consignee.push(orderData?.consignee_name);
                                                order_qty.push((orderData?.plannedWeight?.split(" ")[0] * conversionFactorUnitsToTonne[orderData?.plannedWeight?.split(" ")[1]?.toLowerCase()])?.toFixed(3));
                                                size.push((orderData?.size?.split(" ")[0] * CoversionFactorUnitsToCM[orderData?.size?.split(" ")?.at(-1)?.trim()?.toLowerCase()])?.toFixed(2));
                                                delivery_date.push(orderData?.deliverydate);
                                                grade.push(orderData?.productInfo?.grade);
                                                quality.push(orderData?.productInfo?.quality);
                                                gsm.push(orderData?.productInfo?.gsm);
                                                burst_factor.push(orderData?.productInfo?.burst_factor);
                                                remarks.push(orderData?.remarks || "-")
                                                external_order_id.push(orderData?.external_order_id || "-")
                                            })
                                            orderInfo.po_no.value[i].push(po_no);
                                            orderInfo.customer.value[i].push(customer);
                                            orderInfo.consignee.value[i].push(consignee);
                                            orderInfo.planned_quantity.value[i].push(order_qty);
                                            orderInfo.size.value[i].push(size);
                                            orderInfo.delivery_date.value[i].push(delivery_date);
                                            orderInfo.grade.value[i].push(grade);
                                            orderInfo.quality.value[i].push(quality);
                                            orderInfo.gsm.value[i].push(gsm);
                                            orderInfo.burst_factor.value[i].push(burst_factor);
                                            orderInfo.remarks.value[i].push(remarks);
                                            orderInfo.external_order_id.value[i].push(external_order_id);
                                        }
                                        else{
                                            let orderData = orderDetails.find((order)=>order.orderno == order_no)
                                            let po_no = (orderData?.pono == "null")?"SO":(orderData?.type == "Stock")?"Stock":orderData?.pono?.split("#%#")[0];
                                            orderInfo.po_no.value[i].push(po_no);
                                            orderInfo.customer.value[i].push(orderData?.customername);
                                            orderInfo.consignee.value[i].push(orderData?.consignee_name);
                                            orderInfo.planned_quantity.value[i].push((orderData?.plannedWeight?.split(" ")[0] * conversionFactorUnitsToTonne[orderData?.plannedWeight?.split(" ")[1]?.toLowerCase()])?.toFixed(3));
                                            orderInfo.size.value[i].push((orderData?.size?.split(" ")[0] * CoversionFactorUnitsToCM[orderData?.size?.split(" ").at(-1)?.trim()?.toLowerCase()])?.toFixed(2));
                                            orderInfo.delivery_date.value[i].push(orderData?.deliverydate);
                                            orderInfo.grade.value[i].push(orderData?.productInfo?.grade);
                                            orderInfo.quality.value[i].push(orderData?.productInfo?.quality);
                                            orderInfo.gsm.value[i].push(orderData?.productInfo?.gsm);
                                            orderInfo.burst_factor.value[i].push(orderData?.productInfo?.burst_factor);
                                            orderInfo.remarks.value[i].push(orderData?.remarks || "-");
                                            orderInfo.external_order_id.value[i].push(orderData?.external_order_id || "-")
                                        }
                                    }
                                    else{
                                        orderInfo.reels_count.value[i][ind] = parseInt(orderInfo.reels_count.value[i][ind])+1;
                                        orderInfo.reel_weight.value[i][ind] = order?.reel_type == "intermediate_reel"
                                        ?orderInfo.reel_weight.value[i][ind]?.map((value,i)=>`${(parseFloat(value) + (parseFloat(order?.intermediate_reels_data[i]?.weight) * conversionFactorUnitsToTonne[response1?.units?.weight?.toLowerCase()])).toFixed(3)}`)
                                        :`${(parseFloat(orderInfo.reel_weight.value[i][ind]) + (order?.weight * conversionFactorUnitsToTonne[response1?.units?.weight?.toLowerCase()]))?.toFixed(3)}`;
                                    }
                                }
                            })
                            //sets_length = sum of utilized deckle, net trim and left and right edge trim (incorrect);
                            sets_length = deckle_width + response1[sol][arr[0]]?.trim_loss +  (type=="multiStage"?(response1[sol][arr[0]]?.left_edge_trim + response1[sol][arr[0]]?.right_edge_trim) : (response2?.jobcard?.group?.machines[0]?.left_edge_trim +  response2?.jobcard?.group?.machines[0]?.left_edge_trim));
                            patternInfo.deckle_width.value.push(`${deckle_width?.toFixed(3)} ${response2?.type == "single_stage" ?response1?.units?.order_width : response1?.units?.reel_width}`);
                            setInfo.sets_weight.value.push(`${sets_weight?.toFixed(3)} ${response1?.units?.weight.toUpperCase()}`);
                            setInfo.sets_length.value.push(`${(sets_length).toFixed(3)} ${response1?.units?.trim_loss}`);
                            setInfo.total_set_weight.value.push(`${(sets_weight * parseFloat(response1[sol][arr[0]]?.actual_count))?.toFixed(3)} ${response1?.units?.weight.toUpperCase()}`);

                        }
                    })
                }
                else {
                    response2?.jobcard?.[sol]?.data?.partitions?.forEach((partition,i)=>{

                        //setting pattern info
                        patternInfo?.pattern?.value?.push(`${i+1}.1`);
                        patternInfo?.deckle_width?.value?.push(`${partition?.total_deckle_width || partition?.left_width} ${partition?.units?.breadth}`)
                        patternInfo?.net_trim?.value?.push(`${response2?.process_type == "duplex"?partition?.total_trim_loss_width:partition?.trim_loss_width} ${response2?.process_type == "duplex"?partition?.units?.total_trim_loss_width:partition?.units?.trim_loss_width}`)
                        patternInfo?.edge_trim?.value?.push(`${response2?.jobcard?.group?.machines[0]?.left_edge_trim} ${response2?.jobcard?.group?.machines[0]?.units?.left_edge_trim} (L)/${response2?.jobcard?.group?.machines[0]?.right_edge_trim} ${response2?.jobcard?.group?.machines[0]?.units?.right_edge_trim} (R)`)

                        Object.keys(orderInfo).forEach((key)=>{
                            orderInfo[key]?.value?.push([]);
                        })

                        let set_weight = 0;

                        partition?.partition?.forEach((data,j)=>{
                            let order_no = data?.order_id;

                            set_weight += data?.weight;

                            orderInfo.width.value[i].push(`${(data?.breadth * CoversionFactorUnitsToCM[partition?.units?.breadth])?.toFixed(2)}`);
                            orderInfo.order_no.value[i].push(order_no);
                            orderInfo.reel_weight.value[i].push(`${(data?.weight * conversionFactorUnitsToTonne[partition?.units?.weight?.toLowerCase()])?.toFixed(3)}`);
                            orderInfo.sheeter_pattern.value[i].push(`${data?.breadth} ${partition?.units?.breadth} x ${data?.length} ${partition?.units?.length}`);

                            let orderData = orderDetails.find((order)=>order.orderno == order_no)

                            orderInfo.po_no.value[i].push(orderData?.pono?.split("#%#")[0]);
                            orderInfo.customer.value[i].push(orderData?.customername);
                            orderInfo.consignee.value[i].push(orderData?.consignee_name);
                            orderInfo.planned_quantity.value[i].push((orderData?.plannedWeight?.split(" ")[0] * conversionFactorUnitsToTonne[orderData?.plannedWeight?.split(" ")[1]?.toLowerCase()])?.toFixed(3));
                            orderInfo.size.value[i].push((orderData?.size?.split(" ")[0] * CoversionFactorUnitsToCM[orderData?.size?.split(" ")?.at(-1)?.trim()?.toLowerCase()])?.toFixed(2));
                            orderInfo.delivery_date.value[i].push(orderData?.deliverydate);
                            orderInfo.grade.value[i].push(orderData?.productInfo?.grade);
                            orderInfo.quality.value[i].push(orderData?.productInfo?.quality);
                            orderInfo.gsm.value[i].push(orderData?.productInfo?.gsm);
                            orderInfo.burst_factor.value[i].push(orderData?.productInfo?.burst_factor);
                            orderInfo.remarks.value[i].push(orderData?.remarks || "-");
                            orderInfo.external_order_id.value[i].push(orderData?.external_order_id || "-");
                        })
                        
                        
                        //setting set info
                        setInfo?.sets_count?.value?.push(1)
                        setInfo?.sets_length?.value?.push(`${partition?.total_deckle_width + (response2?.process_type == "duplex"?partition?.total_trim_loss_width:partition?.trim_loss_width) + response2?.jobcard?.group?.machines[0]?.left_edge_trim + response2?.jobcard?.group?.machines[0]?.right_edge_trim} ${partition?.units?.breadth}`)
                        setInfo?.sets_weight?.value?.push(`${set_weight?.toFixed(3)} ${partition?.units?.weight?.toUpperCase()}`);
                        setInfo?.total_set_weight?.value?.push(`${set_weight?.toFixed(3)} ${partition?.units?.weight?.toUpperCase()}`)
                    })
                }

                console.log("od",orderDetails)
                //Setting Data for sheet 2 (summary sheet)
                orderDetails?.forEach((order)=>{
                    orderInfoForSummary?.order_no?.value?.push(order?.orderno);
                    orderInfoForSummary?.po_no?.value?.push(order?.pono?.split("#%#")[0]);
                    orderInfoForSummary?.customer?.value?.push(order?.customername);
                    orderInfoForSummary?.consignee?.value?.push(order?.consignee_name);
                    orderInfoForSummary?.size?.value?.push((order?.size?.split(" ")[0] * CoversionFactorUnitsToCM[order?.units?.size?.split(" ")?.at(-1)?.trim()?.toLowerCase()])?.toFixed(2));
                    orderInfoForSummary?.grain?.value?.push(order?.grain ?? "-");
                    orderInfoForSummary?.order_quantity?.value?.push((order?.orderWeight?.split(" ")[0] * conversionFactorUnitsToTonne[order?.orderWeight?.split(" ")[1]?.toLowerCase()])?.toFixed(3));
                    orderInfoForSummary?.planned_quantity?.value?.push((order?.plannedWeight?.split(" ")[0] * conversionFactorUnitsToTonne[order?.plannedWeight?.split(" ")[1]?.toLowerCase()])?.toFixed(3));
                    orderInfoForSummary?.fulfilled_quantity?.value?.push((order?.fulflilledWeight?.split(" ")[0] * conversionFactorUnitsToTonne[order?.fulflilledWeight?.split(" ")[1]?.toLowerCase()])?.toFixed(3));
                    orderInfoForSummary?.grade?.value?.push(order?.productInfo?.grade);
                    orderInfoForSummary?.quality?.value?.push(order?.productInfo?.quality);
                    orderInfoForSummary?.gsm?.value?.push(order?.productInfo?.gsm);
                    orderInfoForSummary?.burst_factor?.value?.push(order?.productInfo?.burst_factor);
                    orderInfoForSummary?.remarks?.value?.push(order?.remarks || "-");
                    orderInfoForSummary?.external_order_id?.value?.push(order?.external_order_id || "-");
                })

                setPatternData(patternInfo);
                setSetData(setInfo);

                //Ordering keys of orderInfo as per set positoins
                let updatedOrderInfo = {};
                let sortedOrderInfo = Object.entries(orderInfo);

                sortedOrderInfo?.sort((a,b)=> keysData?.orderInfo[a[0]]?.position - keysData?.orderInfo[b[0]]?.position);

                sortedOrderInfo?.forEach((item) => {
                    updatedOrderInfo[item[0]] = orderInfo[item[0]];
                })

                //ordering keys of orderInfoforSummary as per set positions
                let updatedOrderInfoForSummary = {};
                let sortedOrderInfoForSummary = Object.entries(orderInfoForSummary);
                
                sortedOrderInfoForSummary?.sort((a,b)=>(keysData?.orderInfoForSummary[a[0]]?.position - keysData?.orderInfoForSummary[b[0]]?.position));

                sortedOrderInfoForSummary?.forEach((item) => {
                    updatedOrderInfoForSummary[item[0]] = orderInfoForSummary[item[0]];
                })

                setOrderData(updatedOrderInfo);
                setOrderDataForSummary(updatedOrderInfoForSummary);
                console.log("run",runInfo)
                console.log("pattern",patternInfo)
                console.log("set",setInfo);
                console.log("order",updatedOrderInfo)
                console.log("orderSummary",orderInfoForSummary)
                setTimeout(()=>setLoading(false),1000);
            }
            catch(e)
            {
                console.log(e);
                setTimeout(()=>setLoading(false),1000);
            }
        })();
    },[type,jobId,orderDetails,solution]);

    const handleSaveToggles = async() => {
        try{
            const csvFormat = formatsResp?.formats?.filter((format)=>format?.name == "csv_format")[0];

            let keys = {
                "runInfo": {
                    "gsm": {
                        "visible": runData?.gsm?.visible ?? csvFormat?.keys?.runInfo?.gsm?.visible ?? false,
                    },
                    "date": {
                        "visible": runData?.date?.visible ?? csvFormat?.keys?.runInfo?.date?.visible ?? false,
                    },
                    "grade": {
                        "visible": runData?.grade?.visible ?? csvFormat?.keys?.runInfo?.grade?.visible ?? false,
                    },
                    "jc_no": {
                        "visible": runData?.jc_no?.visible ?? csvFormat?.keys?.runInfo?.jc_no?.visible ?? false,
                    },
                    "cutter": {
                        "visible": runData?.cutter?.visible ?? csvFormat?.keys?.runInfo?.cutter?.visible ?? false,
                    },
                    "quality": {
                        "visible": runData?.quality?.visible ?? csvFormat?.keys?.runInfo?.quality?.visible ?? false,
                    },
                    "rewinder": {
                        "visible": runData?.rewinder?.visible ?? csvFormat?.keys?.runInfo?.rewinder?.visible ?? false,
                    },
                    "reels_count": {
                        "visible": runData?.reels_count?.visible ?? csvFormat?.keys?.runInfo?.reels_count?.visible ?? false,
                    },
                    "sheet_count": {
                        "visible": runData?.sheet_count?.visible ?? csvFormat?.keys?.runInfo?.sheet_count?.visible ?? false,
                    },
                    "net_trim_loss": {
                        "visible": runData?.net_trim_loss?.visible ?? csvFormat?.keys?.runInfo?.net_trim_loss?.visible ?? false,
                    },
                    "paper_machine": {
                        "visible": runData?.paper_machine?.visible ?? csvFormat?.keys?.runInfo?.paper_machine?.visible ?? false,
                    },
                    "stock_quantity": {
                        "visible": runData?.stock_quantity?.visible ?? csvFormat?.keys?.runInfo?.stock_quantity?.visible ?? false,
                    },
                    "fulfilled_weight": {
                        "visible": runData?.fulfilled_weight?.visible ?? csvFormat?.keys?.runInfo?.fulfilled_weight?.visible ?? false,
                    },
                    "priority_quantity": {
                        "visible": runData?.priority_quantity?.visible ?? csvFormat?.keys?.runInfo?.priority_quantity?.visible ?? false,
                    },
                    "production_weight": {
                        "visible": runData?.production_weight?.visible ?? csvFormat?.keys?.runInfo?.production_weight?.visible ?? false,
                    },
                    "reels_count_cutter": {
                        "visible": runData?.reels_count_cutter?.visible ?? csvFormat?.keys?.runInfo?.reels_count_cutter?.visible ?? false,
                    },
                    "fulfillment_percent": {
                        "visible": runData?.fulfillment_percent?.visible ?? csvFormat?.keys?.runInfo?.fulfillment_percent?.visible ?? false,
                    }
                },
                "setInfo": {
                    "sets_count": {
                        "visible": setData?.sets_count?.visible ?? csvFormat?.keys?.setInfo?.sets_count?.visible ?? false,
                    },
                    "sets_length": {
                        "visible": setData?.sets_length?.visible ?? csvFormat?.keys?.setInfo?.sets_length?.visible ?? false,
                    },
                    "sets_weight": {
                        "visible": setData?.sets_weight?.visible ?? csvFormat?.keys?.setInfo?.sets_weight?.visible ?? false,
                    },
                    "total_set_weight": {
                        "visible": setData?.total_set_weight?.visible ?? csvFormat?.keys?.setInfo?.total_set_weight?.visible ?? false,
                    }
                },
                "orderInfo": {
                    "size": {
                        "visible": orderData?.size?.visible ?? csvFormat?.keys?.orderInfo?.size?.visible ?? false,
                        "position": Object.keys(orderData)?.indexOf("size"),
                    },
                    "po_no": {
                        "visible": orderData?.po_no?.visible ?? csvFormat?.keys?.orderInfo?.po_no?.visible ?? false,
                        "position": Object.keys(orderData)?.indexOf("po_no"),
                    },
                    "width": {
                        "visible": orderData?.width?.visible ?? csvFormat?.keys?.orderInfo?.width?.visible ?? false,
                        "position": Object.keys(orderData)?.indexOf("width"),
                    },
                    "customer": {
                        "visible": orderData?.customer?.visible ?? csvFormat?.keys?.orderInfo?.customer?.visible ?? false,
                        "position": Object.keys(orderData)?.indexOf("customer"),
                    },
                    "order_no": {
                        "visible": orderData?.order_no?.visible ?? csvFormat?.keys?.orderInfo?.order_no?.visible ?? false,
                        "position": Object.keys(orderData)?.indexOf("order_no"),
                    },
                    "grade": {
                        "visible": orderData?.grade?.visible ?? csvFormat?.keys?.orderInfo?.grade?.visible ?? false,
                        "position": Object.keys(orderData)?.indexOf("grade"),
                    },
                    "quality": {
                        "visible": orderData?.quality?.visible ?? csvFormat?.keys?.orderInfo?.quality?.visible ?? false,
                        "position": Object.keys(orderData)?.indexOf("quality"),
                    },
                    "gsm": {
                        "visible": orderData?.gsm?.visible ?? csvFormat?.keys?.orderInfo?.gsm?.visible ?? false,
                        "position": Object.keys(orderData)?.indexOf("gsm"),
                    },
                    "burst_factor": {
                        "visible": orderData?.burst_factor?.visible ?? csvFormat?.keys?.orderInfo?.burst_factor?.visible ?? false,
                        "position": Object.keys(orderData)?.indexOf("burst_factor"),
                    },
                    "consignee": {
                        "visible": orderData?.consignee?.visible ?? csvFormat?.keys?.orderInfo?.consignee?.visible ?? false,
                        "position": Object.keys(orderData)?.indexOf("consignee"),
                    },
                    "reels_count": {
                        "visible": orderData?.reels_count?.visible ?? csvFormat?.keys?.orderInfo?.reels_count?.visible ?? false,
                        "position": Object.keys(orderData)?.indexOf("reels_count")==-1?csvFormat?.keys?.orderInfo?.reels_count?.position:Object.keys(orderData)?.indexOf("reels_count"),
                    },
                    "delivery_date": {
                        "visible": orderData?.delivery_date?.visible ?? csvFormat?.keys?.orderInfo?.delivery_date?.visible ?? false,
                        "position": Object.keys(orderData)?.indexOf("delivery_date"),
                    },
                    "planned_quantity": {
                        "visible": orderData?.planned_quantity?.visible ?? csvFormat?.keys?.orderInfo?.planned_quantity?.visible ?? false,
                        "position": Object.keys(orderData)?.indexOf("planned_quantity"),
                    },
                    "sheeter_pattern": {
                        "visible": orderData?.sheeter_pattern?.visible ?? csvFormat?.keys?.orderInfo?.sheeter_pattern?.visible ?? false,
                        "position": (Object.keys(orderData)?.indexOf("sheeter_pattern")==-1) ? csvFormat?.keys?.orderInfo?.sheeter_pattern?.position:Object.keys(orderData)?.indexOf("sheeter_pattern") ,
                    },
                    "reel_weight": {
                        "visible": orderData?.reel_weight?.visible ?? csvFormat?.keys?.orderInfo?.reel_weight?.visible ?? false,
                        "position": Object.keys(orderData)?.indexOf("reel_weight"),
                    },
                    "remarks": {
                        "visible": orderData?.remarks?.visible ?? csvFormat?.keys?.orderInfo?.remarks?.visible ?? false,
                        "position": Object.keys(orderData)?.indexOf("remarks"),
                    },
                    "external_order_id": {
                        "visible": orderData?.external_order_id?.visible ?? csvFormat?.keys?.orderInfo?.external_order_id?.visible ?? false,
                        "position": Object.keys(orderData)?.indexOf("external_order_id"),
                    }
                },
                "orderInfoForSummary": {
                    "size": {
                        "visible": orderDataForSummary?.size?.visible ?? csvFormat?.keys?.orderInfoForSummary?.size?.visible ?? false,
                        "position": Object.keys(orderDataForSummary)?.indexOf("size"),
                    },
                    "grain": {
                        "visible": orderDataForSummary?.grain?.visible ?? csvFormat?.keys?.orderInfoForSummary?.grain?.visible ?? false,
                        "position": Object.keys(orderDataForSummary)?.indexOf("grain"),
                    },
                    "po_no": {
                        "visible": orderDataForSummary?.po_no?.visible ?? csvFormat?.keys?.orderInfoForSummary?.po_no?.visible ?? false,
                        "position": Object.keys(orderDataForSummary)?.indexOf("po_no"),
                    },
                    "customer": {
                        "visible": orderDataForSummary?.customer?.visible ?? csvFormat?.keys?.orderInfoForSummary?.customer?.visible ?? false,
                        "position": Object.keys(orderDataForSummary)?.indexOf("customer"),
                    },
                    "order_no": {
                        "visible": orderDataForSummary?.order_no?.visible ?? csvFormat?.keys?.orderInfoForSummary?.order_no?.visible ?? false,
                        "position": Object.keys(orderDataForSummary)?.indexOf("order_no"),
                    },
                    "grade": {
                        "visible": orderDataForSummary?.grade?.visible ?? csvFormat?.keys?.orderInfoForSummary?.grade?.visible ?? false,
                        "position": Object.keys(orderDataForSummary)?.indexOf("grade"),
                    },
                    "quality": {
                        "visible": orderDataForSummary?.quality?.visible ?? csvFormat?.keys?.orderInfoForSummary?.quality?.visible ?? false,
                        "position": Object.keys(orderDataForSummary)?.indexOf("quality"),
                    },
                    "gsm": {
                        "visible": orderDataForSummary?.gsm?.visible ?? csvFormat?.keys?.orderInfoForSummary?.gsm?.visible ?? false,
                        "position": Object.keys(orderDataForSummary)?.indexOf("gsm"),
                    },
                    "burst_factor": {
                        "visible": orderDataForSummary?.burst_factor?.visible ?? csvFormat?.keys?.orderInfoForSummary?.burst_factor?.visible ?? false,
                        "position": Object.keys(orderDataForSummary)?.indexOf("burst_factor"),
                    },
                    "consignee": {
                        "visible": orderDataForSummary?.consignee?.visible ?? csvFormat?.keys?.orderInfoForSummary?.consignee?.visible ?? false,
                        "position": Object.keys(orderDataForSummary)?.indexOf("consignee"),
                    },
                    "order_quantity": {
                        "visible": orderDataForSummary?.order_quantity?.visible ?? csvFormat?.keys?.orderInfoForSummary?.order_quantity?.visible ?? false,
                        "position": Object.keys(orderDataForSummary)?.indexOf("order_quantity"),
                    },
                    "planned_quantity": {
                        "visible": orderDataForSummary?.planned_quantity?.visible ?? csvFormat?.keys?.orderInfoForSummary?.planned_quantity?.visible ?? false,
                        "position": Object.keys(orderDataForSummary)?.indexOf("planned_quantity"),
                    },
                    "fulfilled_quantity": {
                        "visible": orderDataForSummary?.fulfilled_quantity?.visible ?? csvFormat?.keys?.orderInfoForSummary?.fulfilled_quantity?.visible ?? false,
                        "position": Object.keys(orderDataForSummary)?.indexOf("fulfilled_quantity"),
                    },
                    "remarks": {
                        "visible": orderDataForSummary?.remarks?.visible ?? csvFormat?.keys?.orderInfoForSummary?.remarks?.visible ?? false,
                        "position": Object.keys(orderDataForSummary)?.indexOf("remarks"),
                    },
                    "external_order_id": {
                        "visible": orderDataForSummary?.external_order_id?.visible ?? csvFormat?.keys?.orderInfoForSummary?.external_order_id?.visible ?? false,
                        "position": Object.keys(orderDataForSummary)?.indexOf("external_order_id"),
                    }
                },
                "patternInfo": {
                    "dia": {
                        "visible": patternData?.dia?.visible ?? csvFormat?.keys?.patternInfo?.dia?.visible ?? false,
                    },
                    "pattern": {
                        "visible": patternData?.pattern?.visible ?? csvFormat?.keys?.patternInfo?.pattern?.visible ?? false,
                    },
                    "net_trim": {
                        "visible": patternData?.net_trim?.visible ?? csvFormat?.keys?.patternInfo?.net_trim?.visible ?? false,
                    },
                    "edge_trim": {
                        "visible": patternData?.edge_trim?.visible ?? csvFormat?.keys?.patternInfo?.edge_trim?.visible ?? false,
                    },
                    "deckle_width": {
                        "visible": patternData?.deckle_width?.visible ?? csvFormat?.keys?.patternInfo?.deckle_width?.visible ?? false,
                    }
                }
            }

            let updatedFormats = formatsResp?.formats?.map((format)=>{
                if(format?.name == "csv_format")
                    return {
                        keys: keys,
                        name: "csv_format",
                        value: true,
                    }
                else
                    return {
                        ...format
                    }
            });

            let payload = {
                formats: updatedFormats,
            }

            const resp = await saveDefaultSelectionForJobCardPrint(payload);
            notification.success({
                message: "Success",
                description: "CSV field changes saved successfully",
            })
        }
        catch(e)
        {
            console.log(e);
        }
    }

    return(
        <CSVRow>
            <Col span={6} className="siderCSV">
                <div className="header">
                    <div>
                        <h3>Configuration</h3>
                        <Tooltip title="Save Changes">
                            <Button className="edit-Btn" style={{border:"none",margin:"0px",padding:"0px"}} disabled={loading} onClick={handleSaveToggles}>
                                <Iconmoon icon={"floppy"} size={16} color={"#ea655b"} />
                            </Button>
                        </Tooltip>
                    </div>
                    <p>Select which fields to include in export</p>
                </div>
                <Collapse
                    defaultActiveKey={['1','2','3','4']}
                    bordered={false}
                    expandIconPosition="right"
                    className="collapse"
                >
                    {toggleableFields.map((item)=>(
                        <CollapsePanel key={item.key} header={item.label}>
                            {loading?<Skeleton paragraph={{rows:6,width:"100%"}} active/>:item.children}
                        </CollapsePanel>)
                    )}
                </Collapse>
            </Col>
            <Col span={18} className="mainCSV">
                <div>
                    {loading?<Skeleton.Image style={{width: "100%",height:"400px"}}/>:<CSV runData={runData} setData={setData} patternData={patternData} orderData={orderData} orderDataForSummary={orderDataForSummary} print={print} setPrint={setPrint} company={company} selectedSheet={selectedSheet}/>}
                </div>
            </Col>
        </CSVRow>
    )
}

export default CSVJobCardViewer;